.root {
  display: flex;
  flex-direction: column;
  gap: 8px;
}


.empty {
  color: var(--muted);
  font-size: 0.9rem;
  padding: 40px 0;
  text-align: center;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* ── Icon ── */
.icon {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
}

/* ── Card ── */
.card {
  background: var(--surface);
  border-radius: var(--radius);
  overflow: hidden;
}

.cardBtn {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  padding: 16px 18px;
  cursor: pointer;
  color: inherit;
}

.cardBtn:hover {
  background: var(--tint);
}

.cardTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 4px;
}

.cardLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cardDate {
  font-size: 0.88rem;
  color: var(--muted);
}

.cardNth {
  font-size: 0.85rem;
  color: var(--amber-strong);
  opacity: 0.8;
}

.cardRight {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cardDur {
  font-size: 0.9rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--soft);
}

.chevron {
  font-size: 1.1rem;
  color: var(--muted);
  line-height: 1;
  display: inline-block;
  transition: transform 0.2s;
}

.chevronOpen {
  transform: rotate(90deg);
}

.cardName {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text);
  margin-bottom: 5px;
}

/* Routine + description preview row */
.cardSubline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}

.routineName {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--muted);
  flex-shrink: 0;
}

.descPreview {
  font-size: 0.85rem;
  color: var(--muted);
  font-style: italic;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 360px;
}

/* Meta row (exercises, sets, HR, kcal, social) */
.cardMeta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.metaItem {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.88rem;
  color: var(--muted);
}

/* ── Card body ── */
.cardBody {
  border-top: 1px solid var(--border);
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}


/* ── Exercises ── */
.exercises {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.exercise {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.exHeader {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
}

.exName {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text);
}

.muscleTags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.muscleTag {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--soft);
  background: var(--tint);
  border-radius: 999px;
  padding: 2px 8px;
}

.exNotes {
  font-size: 0.88rem;
  color: var(--muted);
  font-style: italic;
  margin: 0;
}

/* ── Sets table ── */
.setsTable {
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
  font-size: 0.9rem;
}

.setsTable th {
  color: var(--muted);
  font-weight: 600;
  font-size: 0.8rem;
  padding: 4px 8px;
  text-align: left;
  border-bottom: 1px solid var(--border);
}

.setsTable td {
  padding: 7px 8px;
  color: var(--soft);
  border-bottom: 1px solid var(--border);
}

.setsTable tr:last-child td { border-bottom: none; }

.thNum,  .tdNum  { width: 28px; }
.thType, .tdType { width: 90px; }
.thRpe,  .tdRpe  { width: 48px; text-align: right; }
.thPr,   .tdPr   { width: 44px; text-align: right; }

.setsTable .tdNum { color: var(--muted); }
.tdRpe { text-align: right; }

/* Set type badges */
.typeBadge {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  border-radius: 999px;
  padding: 2px 8px;
}

.warmup  { background: var(--tint-md); color: var(--soft); }
.drop    { background: var(--amber-dim); color: var(--amber-strong); }
.failure { background: var(--amber-dim); color: var(--amber-strong); }
.myo     { background: var(--amber-dim); color: var(--amber-strong); }

.typeNormal { color: rgba(138, 127, 112, 0.55); }

/* PR */
.prRow td { background: rgba(217, 126, 36, 0.07); }

.prBadge {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--amber-strong);
  background: var(--amber-dim);
  border-radius: 999px;
  padding: 2px 7px;
}

/* ── Muscle distribution ── */
.muscleDist {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
}

.muscleDistRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.muscleDistLabel {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--soft);
  width: 84px;
  flex-shrink: 0;
}

.muscleDistTrack {
  flex: 1;
  height: 6px;
  background: var(--tint-md);
  border-radius: 999px;
  overflow: hidden;
}

.muscleDistBar {
  height: 100%;
  background: var(--amber);
  opacity: 0.7;
  border-radius: 999px;
  min-width: 3px;
}

.muscleDistCount {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
  width: 100px;
  justify-content: flex-end;
  flex-shrink: 0;
}

.muscleDistPct {
  color: rgba(138, 127, 112, 0.75);
  width: 38px;
  text-align: right;
}
